<template>
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.499 6V4M16.499 4V2M16.499 4H14.499M16.499 4H18.499M6.31501 8.68488L2.38529 10.0268C1.93407 10.1809 1.93407 10.8191 2.38529 10.9732L6.31501 12.3151C7.194 12.6153 7.88439 13.3057 8.18455 14.1847L9.5265 18.1144C9.68059 18.5656 10.3188 18.5656 10.4728 18.1144L11.8148 14.1847C12.115 13.3057 12.8053 12.6153 13.6843 12.3151L17.6141 10.9732C18.0653 10.8191 18.0653 10.1809 17.6141 10.0268L13.6843 8.68488C12.8053 8.38472 12.115 7.69433 11.8148 6.81534L10.4728 2.88562C10.3188 2.4344 9.68059 2.4344 9.5265 2.88562L8.18455 6.81534C7.88439 7.69433 7.19401 8.38472 6.31501 8.68488Z"
      stroke="currentColor"
      stroke-width="1.4"
      stroke-linecap="round"
    />
  </svg>
</template>
